import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import { properties } from '../../../../environments/properties';


@Component({
    selector: 'app-credit-preview',
    templateUrl: './credit-preview.component.html',
    styleUrls: ['./credit-preview.component.scss']
})
export class CreditPreviewComponent implements OnInit {

    @Input() userSubscriptionDetails: any;
    @Input() creditPreviewStatus: string;
    @Input() isTrialPlan: boolean;

    public annualCreditDate: any;

    properties = properties;

    constructor(public subscriptionService: SubscriptionService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.getCreditDate();
    }

    getCreditDate() {
        if (this.userSubscriptionDetails && this.userSubscriptionDetails.renewalDate) {
            this.annualCreditDate = this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate);
        }
    }

    goToChangePlan() {
        this.router.navigate(['freshpass/manage/change'], {state: {userSubscriptionDetails: this.userSubscriptionDetails, isRedirectedFromManageLink: true}});
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.analyticsSetLSFPUpdate("upgradeBtn", this.userSubscriptionDetails.subscriptionStatus);
            window['AB'].DATALAYER.updateAnalyticsSubscriptionInfo('change', {});
        }
    }
}
